import { injectable } from 'tsyringe';

@injectable()
export class InvitationUrlFactory {
  make(): string {
    return `${window.location.origin}/#/user-invitation/{token}`;
  }
}
